import { InjectionToken } from "@angular/core";
export var GAME_ENGINE = new InjectionToken("game-engine");
//# sourceMappingURL=service-tokens.js.map